<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="line-spin-fade"
  [fullScreen]="true"
>
  <p style="color: white">Waiting For Response From Active Directory...</p>
</ngx-spinner>